import React from "react";
import { TCText } from "../../../components/TCText/TCText";

type props = {
  value: string;
  title: string;
};

export const MatchStat: React.FC<props> = ({ value, title }) => {
  return (
    <div style={{ flex: 1 }}>
      <TCText style={{ fontSize: 24, fontWeight: 600 }} value={value} />
      <div />
      <div
        style={{
          width: "100%",
          height: 1,
          backgroundColor: "rgba(133, 131, 131, 0.2)",
          marginTop: 5,
          marginBottom: 5,
        }}
      />
      <TCText style={{ fontSize: 10, fontWeight: 400 }} value={title} />
    </div>
  );
};
